import * as React from "react";

const ColorBar = () => (
    <div className="ll-color-bar" />
);

export default ColorBar;